import { agent, API_MAP } from 'helpers';

class ProductService {
  static loadProductById(id: number, ignoreActiveAffiliates: boolean) {
    let ignoreActiveAffiliatesQuery = '';

    if (ignoreActiveAffiliates) {
      ignoreActiveAffiliatesQuery = '?ignore_active_affiliates=true';
    }

    return agent.get(`${API_MAP.loadProductById}${ignoreActiveAffiliatesQuery}`.replace('{id}', id.toString()));
  }

  static listMyProducts(filters: any, pagination: any) {
    let moderationStatus = '';
    let order = '';
    let status = '';
    let title = '';
    let exact_title = '';
    let filter_fix_delivery = '&filter_fix_delivery=false';

    const pg = {
      per_page: pagination?.per_page || 10,
      current_page: pagination?.current_page || 1,
    };

    if (filters) {
      if (filters.moderation_status) {
        moderationStatus += '&moderation_status=' + filters.moderation_status;
      }
      if (filters.status) {
        status += '&status=' + filters.status;
      }
      if (filters.order) {
        order += '&orderby=' + filters.order;
      }
      if (filters.title) {
        if (Number(filters.title)) {
          title += '&id=' + filters.title;
        } else {
          title += '&title=' + encodeURIComponent(filters.title);
        }
      }
      if (filters.exact_title) {
        exact_title += '&exact_title=' + filters.exact_title;
      }

      if (filters.filter_fix_delivery) {
        filter_fix_delivery = '&filter_fix_delivery=true';
      }
    }

    return agent.get(
      `${API_MAP.listMyProducts}?per_page=${pg.per_page}&page=${pg.current_page}${moderationStatus}${status}${order}${title}${exact_title}${filter_fix_delivery}`
    );
  }

  static listMyProductsSales(listAll?: any, pagination?: any, listProducer?: any) {
    if (listAll) {
      return agent.get(`${API_MAP.listMyProductsSales}?list_all=true`);
    }

    if (listProducer) {
      return agent.get(`${API_MAP.listMyProductsSales}?producer_only=true`);
    }

    return agent.get(`${API_MAP.listMyProductsSales}`);
  }

  static listMyVariations(id: number) {
    return agent.get(`${API_MAP.listMyVariations}`.replace('{id}', id.toString()));
  }

  static listCoProducer(id: number) {
    return agent.get(`${API_MAP.listCoProducerByProduct}`.replace('{id}', id.toString()));
  }

  static newProduct(product: any) {
    return agent.post(`${API_MAP.newProduct}`, product);
  }

  static enableMelhorEnvioAuth(melhorEnvioCode: string) {
    return agent.post(`${API_MAP.enableMelhorEnvioIntegration}`, { melhor_envio_code: melhorEnvioCode });
  }

  static getDeliveryIntegrationActiveList() {
    return agent.get(`${API_MAP.getDeliveryIntegrationActiveList}`);
  }

  static editProduct(id: number, product: any) {
    return agent.put(`${API_MAP.editProduct}`.replace('{id}', id.toString()), product);
  }

  static listCategories() {
    return agent.get(`${API_MAP.listCategories}`);
  }

  static listDeliveryMethod(id: number) {
    return agent.get(`${API_MAP.listDeliveryMethodByProduct}`.replace('{id}', id.toString()));
  }

  static listProductBadgesMethod(id: number) {
    return agent.get(`${API_MAP.listProductBadges}`.replace('{id}', id.toString()));
  }

  static listProductInvoiceMethod(id: number) {
    return agent.get(`${API_MAP.listProductInvoice}`.replace('{id}', id.toString()));
  }

  static getAffiliatesProductStatusSummaryMethod(id: number) {
    return agent.get(`${API_MAP.getAffiliatesProductStatusSummary}`.replace('{id}', id.toString()));
  }

  static productStatusMethod(id: number, status: number) {
    return agent.put(`${API_MAP.productStatus}`.replace('{id}', id.toString()), { status });
  }

  static productInviteAffiliateMethod(id: number, emailAffiliate: string) {
    return agent.post(`${API_MAP.productInviteAffiliate}`.replace('{id}', id.toString()), { email: emailAffiliate });
  }

  static productDelivery(id: number, emailCustomer: string) {
    return agent.post(`${API_MAP.productDelivery}`.replace('{id}', id.toString()), { customer_email: emailCustomer });
  }

  static loadFileById(id: number) {
    return agent.get(`${API_MAP.loadFileById}`.replace('{id}', id.toString()));
  }

  static addNewCoproducer(id: number, coproducer: any) {
    return agent.put(`${API_MAP.addNewCoproducer}`.replace('{id}', id.toString()), { coproducers: coproducer });
  }

  static cloneProductById(id: number, parentId?: number) {
    let url = `${API_MAP.cloneProductById}`.replace('{id}', id.toString());
    if (parentId) {
      url += '?parent_id=' + parentId.toString();
    }
    return agent.post(url, {});
  }

  static listProductsChildrenByID(id: number, status?: string) {
    let url = `${API_MAP.listProductsChildren}`.replace('{id}', id.toString());
    if (status && status !== '') {
      url += '&status=' + status;
    }
    return agent.get(url);
  }

  static listProductCampaigns(idProduct: number, pagination?: any, filters?: any, onlyAffiliates?: boolean, producer?: boolean, myLinks?: any) {
    if (producer) {
      return agent.get(`${API_MAP.listProductCampaigns}`.replace('{id}', idProduct.toString()), {
        type: 'producerLinks',
        page: pagination.current_page,
        per_page: pagination.per_page,
        ...filters,
      });
    }

    if (onlyAffiliates) {
      return agent.get(`${API_MAP.listProductCampaigns}`.replace('{id}', idProduct.toString()), {
        type: 'affiliatesLinks',
        page: pagination.current_page,
        per_page: pagination.per_page,
      });
    }

    if (myLinks) {
      return agent.get(`${API_MAP.listProductCampaigns}`.replace('{id}', idProduct.toString()), {
        type: 'myLinks',
        page: pagination.current_page,
        per_page: pagination.per_page,
      });
    }

    return agent.get(`${API_MAP.listProductCampaigns}`.replace('{id}', idProduct.toString()), {
      type: 'producerLinks',
      page: pagination.current_page,
      per_page: pagination.per_page,
    });
  }

  static editProductCampaign(idProduct: number, idCampaign?: number, campaign?: any) {
    return agent.put(`${API_MAP.listProductCampaigns}/`.replace('{id}', idProduct.toString()) + idCampaign, campaign);
  }

  static createProductCampaign(idProduct: number, campaign: any) {
    return agent.post(`${API_MAP.listProductCampaigns}`.replace('{id}', idProduct.toString()), campaign);
  }

  static updatePostback(idProduct: any, script: any, destiny: any, type: any) {
    return agent.post(`${API_MAP.createPosback}`, { product_id: idProduct, script, destiny, type });
  }

  static listPostback(idProduct: any, destiny: any, type: any) {
    return agent.get(`${API_MAP.listPostback}`, { product_id: idProduct, destiny, type });
  }

  static createProductCampaignTracker(tracker: any, id: any) {
    if (!id) {
      return agent.post(`${API_MAP.createTrackers}`, tracker);
    }

    return agent.put(`${API_MAP.createTrackers}/{id}`.replace('{id}', id.toString()), tracker);
  }

  static deleteProductCampaignTracker(id: any, type: string) {
    return agent.del(`${API_MAP.createTrackers}/{id}?type={type}`.replace('{id}', id.toString()).replace('{type}', type));
  }

  static loadProductCampaignTracker(idProduct: any, type?: any) {
    if (!type) {
      return agent.get(`${API_MAP.trackers}`.replace('{product_id}', idProduct.toString()));
    }
    return agent.get(`${API_MAP.trackers}&type={type}`.replace('{product_id}', idProduct.toString()).replace('{type}', type.toString()));
  }

  static verifyDomain(productId: number) {
    return agent.get(`${API_MAP.verifyDomain}?product_id=${productId.toString()}`);
  }

  static listCoupons(idProduct: any, pagination: any, status: string) {
    return agent.get(
      `${API_MAP.listCoupons}?per_page=${pagination.per_page}&page=${pagination.page}&status=${status}`.replace('{id}', idProduct.toString())
    );
  }

  static excludeCoupon(idProduct: any, couponId: any) {
    return agent.post(`${API_MAP.excludeCoupon}`.replace('{product_id}', idProduct.toString()).replace('{id}', couponId.toString()), {});
  }

  static createCoupons(idProduct: any, coupon: any) {
    return agent.post(`${API_MAP.createCoupon}`.replace('{product_id}', idProduct.toString()), coupon);
  }

  static listCoProductions(pagination: any, title?: string) {
    let url = API_MAP.listCoProductions;
    let search = '';

    if (title) {
      if (Number(title)) {
        search += `&product_id=${title}`;
      } else {
        search += `&title=${title}`;
      }
    } else {
      search = '';
    }

    return agent.get(`${url}?per_page=${pagination.per_page}&page=${pagination.current_page}${search}`);
  }

  static listAffiliations(pagination: any, title?: string) {
    let url = API_MAP.listAffiliations;
    let search = '';

    if (title) {
      if (Number(title)) {
        search += `&product_id=${title}`;
      } else {
        search += `&product_title=${title}`;
      }
    } else {
      search = '';
    }

    return agent.get(`${url}?per_page=${pagination.per_page}&page=${pagination.current_page}${search}`);
  }

  static inviteAffiliationsbyEmail(product: any, email: string) {
    return agent.post(`${API_MAP.productInviteAffiliate}`.replace('{id}', product.product_id), {
      email,
      indication: true,
    });
  }

  static cancelAffilation(id: number) {
    return agent.del(`${API_MAP.listAffiliations}/${id}`);
  }

  static listRecoveryMessages(id: number) {
    return agent.get(`${API_MAP.listRecoveryMessages}`.replace('{id}', id.toString()));
  }

  static updateRecoveryMessages(idProduct: any, idMessage: any, message: any) {
    return agent.put(`${API_MAP.updateRecoveryMessages}`.replace('{product_id}', idProduct).replace('{id}', idMessage), message);
  }

  static createRecoveryMessages(idProduct: any, message: any) {
    return agent.post(`${API_MAP.listRecoveryMessages}`.replace('{id}', idProduct), message);
  }

  static listCouponsBatch(idProduct: any, pagination: any, status: string) {
    return agent.get(
      `${API_MAP.listCouponsBatch}?per_page=${pagination.per_page}&page=${pagination.page}&status=${status}`.replace('{id}', idProduct.toString())
    );
  }

  static exportCouponsBatch(idProduct: any, hash: string) {
    return agent.get(`${API_MAP.exportCouponsBatch}`.replace('{id}', idProduct.toString()).replace('{hash}', hash.toString()));
  }

  static createCouponBatch(file: File | Blob, couponsValue: any, productId: number) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('value', couponsValue['value']);
    formData.append('type', couponsValue['type']);
    formData.append('quantity', couponsValue['quantity']);
    formData.append('description', couponsValue['description']);

    if (couponsValue['limeted_date']) {
      formData.append('limeted_date', couponsValue['limeted_date']);
    }

    return agent.post(`${API_MAP.createBatchCoupon}`.replace('{product_id}', productId.toString()), formData);
  }

  static inactivateBatch(idProduct: any, hash: string) {
    return agent.del(`${API_MAP.inactivateCouponsBatch}`.replace('{id}', idProduct.toString()).replace('{hash}', hash.toString()));
  }

  static listProductsCampaignFilter() {
    return agent.get(`${API_MAP.listProductsCampaignFilter}`);
  }

  static loadEditProduct(id: number) {
    return agent.get(`${API_MAP.loadEditProduct}/${id}`);
  }
}
export default ProductService;
